import { RouteObject } from 'react-router-dom';
import MeterFormatDashboard from './components/MeterReadFormat/MeterFormatDashboard';
import AddEditForm from './components/MeterReadFormat/AddEditForm';
import FormatDetailView from './components/MeterReadFormat/FormatDetailView';
import MeterReaderManagement from './components/ServiceExecutives/MeterReaderManagement';
import MeterReadersCodeLanding from './components/MeterReadersCode/MeterReadersCodeLanding';
import Create from './components/MeterReadFormat/create/Create';
import { MeterReadFormatDetailLanding } from './components/MeterReadFormat/detail/Landing';
import ResourcesLanding from './components/resources/Landing';
import ResourceSubtypeDetail from './components/resources/sub-type/detail/Detail';
import ManufacturerModelsLanding from './components/Manufacturer&Models/Landing';
import AddModels from './components/Manufacturer&Models/create/AddModels';
import { MeterModelDetailLanding } from './components/Manufacturer&Models/detail/models/Landing';
import ConditionsLanding from './components/conditions/Landing';
import AddConditionStatus from './components/conditions/create/AddConditionStatus';
import AddConditionReason from './components/conditions/create/AddConditionReason';
import SettingsLanding from './components/Landing';

export interface mxSettingsRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: mxSettingsRoute[];
}

export const mxSettingsRoutes: mxSettingsRoute[] = [
  {
    path: 'mx/settings',
    element: <SettingsLanding />
  },
  {
    path: 'mx/settings/models/add',
    element: <AddModels />
  },
  {
    path: 'mx/settings/models/edit/:id',
    element: <AddModels />
  },
  {
    path: 'mx/settings/models/view/:id',
    element: <MeterModelDetailLanding />
  },
  {
    path: 'mx/settings/resources/sub-type/:id',
    // auth: true,
    element: <ResourceSubtypeDetail />
  },
  {
    path: 'mx/settings/meterread-format/add',
    // auth: true,
    element: <Create />
  },
  {
    path: 'mx/settings/meterread-format/edit/:id',
    // auth: true,
    element: <Create />
  },
  {
    path: 'mx/settings/meterread-format/view/:id',
    // auth: true,
    element: <MeterReadFormatDetailLanding />
  },
];